import TipoChavePixService from "../../services/TipoChavePixService";
import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormTipoChavePix from "../../pages/TipoChavePix/FormTipoChavePix";
import Permissao from "../../controllers/Permissao";

export default class SelectTipoChavePix extends FormSelectSearchModal {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);

        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(54));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
    }

    getConfigFormNew() {
        return {
            title: 'Cadastro de Tipo de Chave Pix',
            sizeModal: 'modal-xl',
            config: {
                isModal: true
            },
            form: FormTipoChavePix,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idTipoChavePix) {
                        this.handleOpenSearch(null, response.data?.idTipoChavePix);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    };

    componentDidMount() {
        super.componentDidMount();
        this.getOptions(() => {
            if (this.dispachChangeDidMount && this.props.value) {
                this.handleChange({ target: { value: this.props.value, name: this.props.name } });
            }
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        TipoChavePixService.getForCombo((response) => {
            this.setState({ options: response }, () => {
                if (callBack) {
                    callBack();
                }
            });
        });
    }

    render() {
        return super.render();
    }
}